import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";

const links = [
  { to: "/", label: "Synopsis", jp: "壱", id: "synopsis" },
  { to: "/author", label: "Author", jp: "弐", id: "author" },
  { to: "/film-options", label: "Film Options", jp: "参", id: "options" },
  { to: "/pitch-deck", label: "Pitch Deck", jp: "肆", id: "pitch" },
];

const Item = ({ l, onClick }) => (
  <NavLink
    to={l.to}
    end
    onClick={onClick}
    data-testid={`nav-item-${l.id}`}
    className={({ isActive }) =>
      `group flex items-baseline gap-2 font-mono-s text-xs uppercase tracking-[0.25em] transition-colors duration-300 ${isActive ? "text-[#E2E0D8]" : "text-[#A3ACBB] hover:text-[#E2E0D8]"}`
    }
  >
    {({ isActive }) => (
      <>
        <span className={`font-display text-sm ${isActive ? "text-[#C81D25]" : ""}`}>{l.jp}</span>
        <span className="link-underline pb-1">{l.label}</span>
      </>
    )}
  </NavLink>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#07080B]/50 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-10">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <LogoMark className="h-8 w-8 transition-transform duration-500 hover:rotate-[-8deg]" />
          <span className="font-brush text-xl tracking-[0.25em] text-[#C81D25] ink-damage-sm">MINKA</span>
        </Link>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => <Item key={l.to} l={l} />)}
          <Link to="/film-options" data-testid="nav-cta-request" className="rounded-full border border-[#C81D25]/60 px-5 py-2 font-mono-s text-xs uppercase tracking-[0.2em] text-[#E2E0D8] transition-colors duration-300 hover:bg-[#C81D25]">
            Option the Script
          </Link>
        </nav>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="text-[#E2E0D8] md:hidden" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-white/5 bg-[#07080B]/95 md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-6 px-5 py-8">
              {links.map((l) => <Item key={l.to} l={l} onClick={() => setOpen(false)} />)}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
